export enum MaxImageSizes {
  SMALL_IMAGE = 600,
  IMAGE = 1920,
  BACKGROUND_IMAGE = 2500
}
